export enum PopupWhoseEnum {
    RegisteredMembers = 1,
    ActiveStudents = 2,
    Everyone = 3
  }
  